var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height",attrs:{"fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{staticClass:"text-center"},[_vm._v(" PAGE NOT FOUND! ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }